import { useUserMedia } from '@vueuse/core';

export const cameraSettings = {
  width: { min: 480, max: 1080, ideal: 1080 },
  height: { min: 480, max: 1080, ideal: 1080 },
  aspectRatio: { ideal: 1 },
};

export const constraints = {
  video: {
    cameraSettings,
    facingMode: 'user',
  },
};

export const isCameraConsented = async () => {
  const { isSupported, stop, start } = useUserMedia({ constraints });

  if (!isSupported) {
    return { isConsented: false, erroMenssage: 'cameraMissing' };
  }
  await start();
  stop();

  return { isConsented: true, erroMenssage: '' };
};
